module.exports = __webpack_public_path__ + "img/down_arrow.e7cdaf55.svg";